var render = function render(){var _vm=this,_c=_vm._self._c;return (true)?_c('orders-download-file-dialog',{attrs:{"opened":true,"choices":_vm.choices,"unloading-from":_vm.unloadingFrom,"names":'viewer'},on:{"close":_vm.closeDialog}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }